import { useSyncExternalStore } from "react";

// The conflict dialog is one for the app (rendered by DraftHost): whoever
// gets a refused save opens it with the conflicts of the 409 and what
// "Discard my changes and reload" does for it.
let current = null;
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener());

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// conflicts: [{ type, id, baseVersion, storedVersion, lastSaved }] (the 409)
// or the live conflicts of a scope ({ accessor, id, serverVersion, ... }),
// or the ones of draft.conflictsOf (form: true for the row of an open form).
// onDiscard(): "Discard my changes and reload" (resolves once reloaded).
// onRebase(items): "Apply my changes on their version" (optional: no Rebase
// without it), called on Confirm of the preview with the rows that merge:
// [{ accessor, id, title, row, version, base, theirs, mine }] (row: mine
// applied on theirs, diff.js's merge; version: theirs'). Returns what the
// opener's rebase returns ({ rebased, refused }: draft.rebaseConflicts; a
// refused row keeps the dialog open). useDraftSave's rebases the rows of
// its draft (rebaseConflicts(scope, the items' keys, merge)); the Item's
// rebases its form (its row) and its draft (the other rows).
// mineOf(accessor, id): the user's row, for "What changed", Rebase and
// "Copy my values" (undefined: not known; null: deleted by the user). The
// Item's: its form values for its row; a draft's: its row in the journal
// (draftMineOf, present.js).
// The rows of the conflicts: draft.conflictVersions(accessor, id).
// Any other field of the payload (e.g. onKeepEditing) is kept as given.
export function showConflicts(payload = {}) {
  current = { ...payload, conflicts: payload.conflicts ?? [] };
  emit();
}

export function closeConflicts() {
  current = null;
  emit();
}

export function useConflictDialog() {
  return useSyncExternalStore(subscribe, () => current);
}
